import { PNotify } from '@sop/unify-pnotify';// '../../pnotify/pnotify-js.js';
import '@sop/unify-bootstrapdatepicker';// '../../bootstrap-datepicker/bootstrap-datepicker-js';
import { Foldout } from './foldout';

import { Search } from './Search.js';
import * as utils from './utils.js';
import { Modals } from './modals.js';
import { Datepicker } from './datepicker.js';

$(document).ready(function () {
    // set default styling of pNotify to font-awesome
    if (typeof PNotify !== "undefined") {
        PNotify.prototype.options.styling = "fontawesome";
    }

    // Toggle foldouts on click
    $('.' + Foldout.CLASS + ':not(.' + Foldout.CLASS_DISABLE_COLLAPSE + ') > .' + Foldout.CLASS_TITLE)
        .on('click.unify', function (event) {
            var foldout = new Foldout();
            foldout.toggle($(event.target).closest('.' + Foldout.CLASS));
        });

    utils.closePopoverIfClickingOnBody();

    // set default sp-arrows as icons on datepicker
    $.fn.datepicker.defaults.templates = { leftArrow: '<i class="sp sp-arrow_left sp-2x"></i>', rightArrow: '<i class="sp sp-arrow_right sp-2x"></i>' };

    var search = new Search();
    search.initialize();

    var modals = new Modals();
    modals.initialize();

    var datepicker = new Datepicker();
    datepicker.initialize();

    utils.inlineExternalSVGs();
});
